export const buildOrderIndex = (order: readonly string[]): Map<string, number> => {
	const m = new Map<string, number>();
	order.forEach((k, i) => m.set(k, i));
	return m;
};
